var _path, _path2, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSatisfactionLevel4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H58V58H0V0Z",
    fill: "#25C1E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 35C21.4477 35 20.9875 35.4578 21.1563 35.9836C21.2583 36.3012 21.4097 36.6127 21.609 36.9134C22.011 37.52 22.6003 38.0712 23.3431 38.5355C24.086 38.9998 24.9679 39.3681 25.9385 39.6194C26.9091 39.8707 27.9494 40 29 40C30.0506 40 31.0909 39.8707 32.0615 39.6194C33.0321 39.3681 33.914 38.9998 34.6569 38.5355C35.3997 38.0712 35.989 37.52 36.391 36.9134C36.5903 36.6127 36.7417 36.3012 36.8437 35.9836C37.0125 35.4578 36.5523 35 36 35L34.457 35C33.9047 35 33.4666 35.4738 33.189 35.9513C33.1666 35.9898 33.1428 36.0281 33.1177 36.066C32.8937 36.404 32.5654 36.711 32.1515 36.9697C31.7377 37.2284 31.2463 37.4336 30.7056 37.5736C30.1649 37.7135 29.5853 37.7856 29 37.7856C28.4147 37.7856 27.8351 37.7135 27.2944 37.5736C26.7537 37.4336 26.2623 37.2284 25.8485 36.9697C25.4346 36.711 25.1063 36.404 24.8823 36.066C24.8572 36.0281 24.8334 35.9898 24.811 35.9513C24.5334 35.4738 24.0953 35 23.543 35L22 35Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 23,
    r: 3,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 23,
    r: 3,
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatisfactionLevel4);
export default __webpack_public_path__ + "static/media/satisfaction_level_4.3cd449ff87ab42e65f1924f3864b0fec.svg";
export { ForwardRef as ReactComponent };